import { Injector, NgModule } from '@angular/core';
import { Http } from '@angular/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { FormPageModule } from '../vas/pages/form/form.module';
import { LoginPageModule } from '../vas/pages/login/login.module';
import { RootPageModule } from '../vas/pages/root/root.module';
import { ServiceLocator } from '../vas/services/locator.service';
import { MyApp } from './app.component';
import { createTranslateLoader } from './app.module.helpers';
import { SideMenuModule } from './atoms/side-menu/side-menu.module';
import { CoreModule } from './core.module';

@NgModule({
    declarations: [
        MyApp
    ],
    imports: [
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [Http]
            }
        }),
        CoreModule,
        IonicModule.forRoot(MyApp),
        RootPageModule,
        FormPageModule,
        LoginPageModule,
        SideMenuModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp
    ]
})
export class AppModule {
    constructor(private injector: Injector) {    // Create global Service Injector.
        ServiceLocator.injector = this.injector;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts